import { makeAutoObservable } from "mobx";
import apiClient, { plainApiClient } from "../api";
import {
  devideUGLSubAssetClass,
  getCurrentDate,
  getCurrentTime,
  getDateInNum,
  getDecodedToken,
  getReportType,
  getTaxAccordionData,
  getTaxTableData,
  sortAccount,
} from "../utils/functions";
import { Buffer } from "buffer";
import AuthStore from "./AuthStore";
import UserStore from "./UserStore";
import PerformanceStore from "./PerformanceStore";
import { getCookie, setCookie } from "../utils/cookie";
import { familyMembers } from "../api/hooks/profile";
import {
  billsFilter,
  emailIdsTax,
  emailIdsTaxClient,
  getDenominations,
  getTaxReportPdf,
  getUsersInception,
  ledgerReport,
  ledgerReportDetails,
  marginFilter,
  portfolioAssetClasses,
  sections,
  subAssetClassData,
  taxFilter,
  transactionFilter,
  transactionUpcomingFilter,
  unrealisedGLReportPDfDownload,
  usersAccount,
} from "../api/hooks/reports";

class ReportsStore {
  allMembersData = null;
  allAssetClassesData = null;
  allSubAssetClassesData = null;
  subAssetFiltered = {};
  allAccountsData = null;
  filterApplied = false;
  tableDataLoader = true;
  transectionReportFilter = {
    timePeriod: "current_month",
    transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
    upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
    selectedMember: "All",
    selectedAssetClass: "All",
    selectedAccount: "All",
  };
  unrealisedReportFilter = {
    selectedMember: undefined,
    selectedAssetClass: "All",
    selectedSubAssetClass: "All",
    selectedAccount: "All",
  };
  unrealisedReportData = undefined;
  unrealisedChecks = {
    memberSuccess: 0,
    accountsSuccess: 0,
    assetClasses: 0,
    subAssetClasses: 0,
  };
  unrealisedLoader = true;
  unrealAssetClassesStatus = false;
  allMembersAPIcallstate = "idle";
  allAssetClassesAPIcallstate = "idle";
  allAccountsAPIcallstate = "idle";
  inceptionDate = null;
  transectionTableData = null;
  rememberedTransectionTableData = null;
  upcomingtransectionTableData = null;
  rememberedupcomingtransectionTableData = null;
  selectedTabForTransaction = "recent_transaction";

  // transaction-corporate-action states
  transectionCorporateActionReportFilter = {
    timePeriod: "current_fy",
    transectionType: "interest",
    selectedMember: "All",
    selectedAssetClass: "All",
  };
  transectionCorporateTableData = null;
  upcomingtransectionCorporateTableData = null;
  selectedTabForTransactionCorporate = "recent_transaction_corporate";

  // ledger-report states
  isInitialAccountSelected = false;
  ledgerReportFilter = {
    timePeriod: "current_year",
    reportType: "snapshot",
    selectedAccount: {},
    selectedSegment: {
      title: "All",
      id: "1",
    },
  };
  forLedgerNoDataScreen = null;
  ledgerSnapshotData = null;
  ledgerSnapshotRawData = null;
  ledgerDetailedViewTableData = null;
  rememberLedgerDetailedData = null;
  ledgerSnapshotAssetModalTableData = null;
  ledgerSnapshotAssetModalTableDataLoader = false;

  // portfolio report states
  allSections = null;
  allDenominations = {};
  emailIdDataForPortfolio = null;
  portfolioReportData = null;
  portfolioReportFilter = {
    timePeriod: "current_fy",
    denomination: {},
    selectedMember: "All",
    selectedAccount: "All",
    selectedAcquisitionDate: "Transfer-In Date",
    selectedSection: [1, 3],
  };
  isFetchingDenominations = false;
  excelDownloadStatus = "";
  // margin sections state
  isFilterApplied = false;
  selectedMarginAccount = "";
  usersAccountsfetchingStatus = "";
  isUsersAdded = false;
  usersAccounts = [];
  selectedAccount = {};
  overviewFilterData = [];
  valuationFilterData = [];
  valuationTotal = [];
  mapUsersList = [];
  marginAllAccountsSuccess = false;
  // bills and contract
  currentFamilyMembers = [];
  selectedReportType = "1";
  selectedSegment = "0";
  fromDate = null;
  toDate = null;
  contractnBillData = [];
  billfromDate = null;
  billtoDate = null;
  checkedArray = null;
  //tax reports
  selectedUserForEmail = "selfEmail";
  selectedUserForName = "selfName";
  selectedCharge = "0";
  emailIdDataForTax = {};
  canCallEmailApi = null;
  taxType = "Asset";
  assetData = [];
  interestData = [];
  assetTotal = null;
  intTotal = null;
  interestDivTotal = null;
  isTaxSendEmail = "";
  emailReportModalLoader = false;
  emaiDataGetSuccess = false;
  emailSendSuccess = false;
  reportsAsOfDate = "";
  taxFromDate = {};
  taxToDate = {};
  taxReportEditColumnsNames = [
    {
      title: "Security Name",
      checked: true,
    },
    {
      title: "ISIN",
      checked: true,
    },
    {
      title: "Security Class",
      checked: true,
    },
    {
      title: "Quantity/Units",
      checked: true,
    },
    {
      title: "Buy Date",
      checked: true,
    },
    {
      title: "Sell Date",
      checked: true,
    },
    {
      title: "Buy Price in Rs",
      checked: true,
    },
    {
      title: "GF Price in Rs",
      checked: true,
    },
    {
      title: "Short Term",
      checked: false,
    },
    {
      title: "Sell Price in Rs",
      checked: false,
    },
    {
      title: "Buy Value in Rs",
      checked: false,
    },
    {
      title: "Indexation Price",
      checked: false,
    },
    {
      title: "Sell Value in Rs",
      checked: false,
    },
    {
      title: "Indexation Price",
      checked: false,
    },
    {
      title: "Indexation value",
      checked: false,
    },
    {
      title: "LTP",
      checked: false,
    },
    {
      title: "STT Buy",
      checked: false,
    },
    {
      title: "Taxable G/L with Indexation",
      checked: false,
    },
    {
      title: "Holding Days",
      checked: false,
    },
    {
      title: "Brokerage",
      checked: false,
    },
    {
      title: "Stamp Duty",
      checked: false,
    },
    {
      title: "Other Charges Buy",
      checked: false,
    },
    {
      title: "STT Sell",
      checked: false,
    },
    {
      title: "Other Charges Sell",
      checked: false,
    },
  ];
  downloadTrigger = [];
  rememberedtransectionCorporateTableData = [];

  constructor() {
    makeAutoObservable(this);
  }

  populateUnrealisedReportData() {
    let userId;
    if (
      getDecodedToken()?.user_type === "employee" ||
      getDecodedToken()?.user_type === "manager"
    ) {
      userId = UserStore?.userData?.user_id;
    } else {
      userId = getDecodedToken()?.user_id;
    }
    this.populateReportsData(undefined, true);

    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false")
    ) {
      this.getAllAccountsData(
        {
          userId: UserStore?.userData?.user_id,
          len: 1,
        },
        "from0",
      );
    }

    this.getAssetClassesOfUser(userId, { onSuccess: () => {} });
  }

  getAssetClassesOfUser(id, { onSuccess }, memberClicked) {
    this.getUnrealisedAssetAndSubAssetClass({
      userId: id || UserStore.userData.user_id,
      onSuccess,
      isMemberChanged: memberClicked,
    });
  }

  getUnrealisedReport(isInception, onSuccess) {
    let selectedAccounts;
    if (this.unrealisedReportFilter.selectedAccount === "All") {
      selectedAccounts = 0;
    } else {
      selectedAccounts =
        this.unrealisedReportFilter.selectedAccount.account_Code;
    }

    let loggedInUserId = getCookie("userid");
    const classID = this.unrealisedReportFilter.selectedAssetClass.classID;
    const subAssetClassId =
      this.unrealisedReportFilter.selectedSubAssetClass?.classID;

    apiClient
      .get(
        `/UnrealisedReports?userid=${loggedInUserId}&asset_class_id=${
          classID && classID !== "noasset" ? classID : "0"
        }&sub_asset_class_id=${
          subAssetClassId && subAssetClassId !== "noasset"
            ? subAssetClassId
            : "0"
        }&account=${selectedAccounts}&membercode=${
          this.unrealisedReportFilter.selectedMember?.user_id
        }&isinception=${isInception}`,
      )
      .then(({ data }) => {
        this.unrealisedReportData = [...data]
          ?.sort((a, b) =>
            b?.["instrumentName"].localeCompare(a?.["instrumentName"]),
          )
          ?.reverse();
        this.updateTableDataLoader(false);
        onSuccess && onSuccess();
      })
      .catch(() => {
        this.unrealisedReportData = [];
        this.updateTableDataLoader(false);
      });
  }

  getUnrealisedReportAllExcel({
    controllerAll,
    filterData,
    onSuccess,
    onFail,
  }) {
    let selectedAccounts;
    const { selectedMember, selectedAccount, subAssetClasses, isInception } =
      filterData;
    const { folios, folioKeys, nonFolioKeys } =
      devideUGLSubAssetClass(subAssetClasses);

    // folios are array sub asset classes of folio instruments
    // folioKeys and nonFolioKeys are object containing assetclass ids
    // (If its sub asset comes under folio then asset class id will go in folio else in non folio , one class can come under both) as keys and its type is array

    const folioInstrument = { ...folioKeys };
    const nonFolioInstrument = { ...nonFolioKeys };

    if (selectedAccount === "All") {
      selectedAccounts = 0;
    } else {
      selectedAccounts = selectedAccount.account_Code;
    }

    let loggedInUserId = getCookie("userid");

    apiClient
      .get(
        `/UnrealisedReports?userid=${loggedInUserId}&asset_class_id=${"0"}&sub_asset_class_id=${"0"}&account=${selectedAccounts}&membercode=${
          selectedMember?.user_id
        }&isinception=${isInception}`,
        { signal: controllerAll.signal },
      )
      .then(({ data }) => {
        const AllExcelData = [...data]
          ?.sort((a, b) =>
            b?.["instrumentName"].localeCompare(a?.["instrumentName"]),
          )
          ?.reverse();

        AllExcelData.forEach((uglData) => {
          // these are folio instrument
          if (folios?.includes(String(uglData.subAssetClassId)))
            folioInstrument[uglData.assetClassId].push(uglData);
          // these are non-folio instrument
          else nonFolioInstrument[uglData.assetClassId].push(uglData);
        });

        onSuccess({ folioInstrument, nonFolioInstrument });
      })
      .catch((error) => {
        onFail(error);
      });
  }

  getSubAssetClassesData({ familyId, assetClassId }) {
    // apiClient
    //   .get(
    //     `families/${familyId}/portfolioassetclasses?classType=SubAssetClass&assetClassId=${assetClassId}`
    //   )
    subAssetClassData({ isFamily: "families", id: familyId, assetClassId })
      .then(({ data }) => {
        this.allSubAssetClassesData = data;
        this.allSubAssetClassesAPIcallstate = "success";
        this.subAssetFiltered = {
          ...this.subAssetFiltered,
          [assetClassId]: data,
        };
      })
      .catch((error) => {
        this.allSubAssetClassesAPIcallstate = "failure";
      });
  }
  getSubAssetClassesDataWithClient({ userId, assetClassId }) {
    subAssetClassData({ isFamily: "clients", id: userId, assetClassId })
      .then(({ data }) => {
        this.allSubAssetClassesData = data;
        this.allSubAssetClassesAPIcallstate = "success";
        this.subAssetFiltered = {
          ...this.subAssetFiltered,
          [assetClassId]: data,
        };
      })
      .catch((error) => {
        this.allSubAssetClassesAPIcallstate = "failure";
      });
  }

  //keep this funciton
  async populateReportsData(reportType, unrealised) {
    let userId;
    let familyId;

    // set user id according to family or client selection

    const {
      user_type: tokenUsertype,
      user_id: tokenUserId,
      family_id: tokenFamId,
      primary: tokenUserPrimary,
    } = getDecodedToken();

    const {
      user_id: userDataId,
      family_id: userDataFamId,
      isprimary: userDataIsPrimary,
    } = UserStore.userData;

    const isEmployee = tokenUsertype === "employee";
    const isManager = tokenUsertype === "manager";
    const isCustomer = tokenUsertype === "customer";
    const storeTransacSelectedUser =
      UserStore.transectionReportFilter.selectedMember;

    if (isEmployee || isManager) {
      userId = userDataId || getCookie("userid");
      familyId = userDataFamId || getCookie("famid");
    } else {
      userId = tokenUserId || getCookie("userid");
      familyId = tokenFamId || getCookie("famid");
    }

    // make all api status to pending , which is necessary for getting api fetching conditions

    this.allMembersAPIcallstate = "pending";
    this.allAssetClassesAPIcallstate = "pending";
    this.allAccountsAPIcallstate = "pending";

    const isFamilyLevel =
      (isEmployee || isCustomer) &&
      JSON.parse(getCookie("isPrimary")) &&
      UserStore.getData === "fam";

    // this works in the case of transaction report
    if (!unrealised) {
      if (isFamilyLevel) {
        UserStore.getFamilyClients(
          null,
          (data) => {
            this.unrealisedReportFilter.selectedMember = data[0];
            this.unrealisedChecks.memberSuccess = 1;
            this.allMembersAPIcallstate = "success";
            AuthStore.updateLoadingFullScreen(false);
            data?.forEach((eachClient, index) => {
              this.getAllAccountsData(
                {
                  userId: eachClient.user_id,
                  isLastClient: data?.length - 1 === index,
                  isFirstClient: index === 0,
                  reportType,
                  idx: index,
                  len: data.length,
                },
                "from1",
              );
            });
          },
          () => {
            this.allMembersAPIcallstate = "failure";
            AuthStore.updateLoadingFullScreen(false);
          },
        );
      }
    }
    if (unrealised) {
      if (isManager || (isCustomer && !JSON.parse(getCookie("isPrimary")))) {
        this.unrealisedReportFilter.selectedMember = UserStore.userData;
        this.unrealisedChecks.memberSuccess = 1;
        this.allMembersAPIcallstate = "success";
        AuthStore.updateLoadingFullScreen(false);
        this.getAllAccountsData(
          {
            userId: UserStore?.userData?.user_id || getCookie("userid"),
            isLastClient: true,
            reportType,
            len: 1,
          },
          "from2",
        );
      } else {
        UserStore.getFamilyClients(
          null,
          (data) => {
            this.unrealisedReportFilter.selectedMember = data.find(
              (eachMember) => {
                return String(eachMember.user_id) === String(userId);
              },
            );
            this.unrealisedChecks.memberSuccess = 1;
            this.allMembersAPIcallstate = "success";
            AuthStore.updateLoadingFullScreen(false);
            data?.forEach((eachClient, index) => {
              this.getAllAccountsData(
                {
                  userId: eachClient.user_id,
                  isLastClient: data?.length - 1 === index,
                  isFirstClient: index === 0,
                  reportType,
                  idx: index,
                  len: data.length,
                },
                "from3",
              );
            });
          },
          () => {
            this.allMembersAPIcallstate = "failure";
            AuthStore.updateLoadingFullScreen(false);
          },
        );
      }
    }
    if (
      isManager ||
      (isEmployee && (!userDataIsPrimary || UserStore.getData !== "fam")) ||
      (isCustomer &&
        (!JSON.parse(getCookie("isPrimary")) || UserStore.getData !== "fam"))
    ) {
      this.allMembersAPIcallstate = "success";
      AuthStore.updateLoadingFullScreen(true);
      this.getAllAccountsData(
        {
          userId: userDataId || getCookie("userid"),
          isFirstClient: true,
          reportType,
          len: 1,
        },
        "from4",
      );
    }

    if (!unrealised) {
      if (
        isManager ||
        (isEmployee && UserStore?.selectedClientId !== "0") ||
        (isCustomer && tokenUserPrimary === "false") ||
        UserStore?.selectedClientId !== "0" ||
        (typeof storeTransacSelectedUser !== "string" &&
          storeTransacSelectedUser?.length === 1)
      ) {
        this.getAssetClassesDataWithClient({ userId });
      } else {
        await this.getAssetClassesData({ familyId });
      }
    }
    if (reportType === "portfolio") {
      this.getDenominations({
        isOffshore:
          getReportType(UserStore.portfolioReportFilter, UserStore.userData) ||
          0,
      });

      this.getSections();
      if (!isCustomer) {
        this.getEmailId({
          empCode: tokenUserId,
          userId: getCookie("selectedUsersId"),
        });
      } else {
        this.getEmailId({ empCode: "", userId: getCookie("selectedUsersId") });
      }
    }
  }

  updateReportsTodefault(check) {
    UserStore.transectionReportFilter = {
      timePeriod: "current_month",
      transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
      upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
      selectedMember: "All",
      selectedAssetClass: "All",
      selectedAccount: "All",
      selectedAcquisitionDate: "",
    };
  }

  setNomPrimaryClientReportData(data, check) {
    if (!data?.isprimary) {
      UserStore.transectionReportFilter = {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
        selectedMember: [data],
        selectedAssetClass: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "",
      };
    } else {
      UserStore.transectionReportFilter = {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
        selectedMember: "All",
        selectedAssetClass: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "",
      };
    }
  }

  setNomPrimaryClientPortfolioReportData(data, mod) {
    if (!data?.isprimary) {
      UserStore.portfolioReportFilter = {
        timePeriod: "current_month",
        denomination: {},
        selectedMember: data,
        selectedAccount: "All",
        selectedAcquisitionDate: "Transfer-In Date",
        selectedSection: [1, 3],
      };
    } else {
      UserStore.portfolioReportFilter = {
        timePeriod: "current_month",
        denomination: {},
        selectedMember: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "Transfer-In Date",
        selectedSection: [1, 3],
      };
    }
  }

  updateTransectionFilter(data, check) {
    UserStore.transectionReportFilter = data;
  }
  updateTransactionFilterData(data, check) {
    if (data !== "All")
      UserStore.transectionReportFilter = {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
        selectedMember: [data],
        selectedAssetClass: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "",
      };
    else {
      UserStore.transectionReportFilter = {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
        selectedMember: "All",
        selectedAssetClass: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "",
      };
    }
  }

  updatePortfolioReportFilterData(data, mod) {
    if (data !== "All") {
      UserStore.portfolioReportFilter = {
        timePeriod: "current_month",
        denomination: {},
        selectedMember: data,
        selectedAccount: "All",
        selectedAcquisitionDate: "Transfer-In Date",
        selectedSection: [1, 3],
      };
    } else {
      UserStore.portfolioReportFilter = {
        timePeriod: "current_month",
        denomination: {},
        selectedMember: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: "Transfer-In Date",
        selectedSection: [1, 3],
      };
    }
  }

  updateCorporateFilterData(data) {
    if (data !== "All") {
      UserStore.transectionCorporateActionReportFilter = {
        timePeriod: "current_fy",
        transectionType: "interest",
        selectedMember: data !== "0" ? [data] : "All",
        selectedAssetClass: "All",
      };
    } else {
      UserStore.transectionCorporateActionReportFilter = {
        timePeriod: "current_fy",
        transectionType: "interest",
        selectedMember: "All",
        selectedAssetClass: "All",
      };
    }
  }

  updateUnrealisedFilter(data) {
    this.unrealisedReportFilter = data;
  }

  updateTransectionCorporateActionFilter(data) {
    UserStore.transectionCorporateActionReportFilter = data;
  }

  updateLedgerFilter(data, from) {
    this.ledgerReportFilter = data;
  }

  updateLedgerReportTypeFilter(data) {
    this.ledgerReportFilter = {
      ...this.ledgerReportFilter,
      reportType: data,
    };
  }

  updateTableDataLoader(data) {
    this.tableDataLoader = data;
  }

  updateEmailReportModalLoader(data) {
    this.emailReportModalLoader = data;
  }

  UpdateledgerSnapshotAssetModalTableDataLoader(data) {
    this.ledgerSnapshotAssetModalTableDataLoader = data;
  }

  updateTransectionReportTab(data) {
    this.selectedTabForTransaction = data;
  }

  updateTransectionCorporateReportTab(data) {
    this.selectedTabForTransactionCorporate = data;
  }

  updateUnrealisedRowData(data) {
    this.unrealisedReportData = data;
  }
  updateAccounts(userId, data) {
    this.allAccountsData = {
      ...this.allAccountsData,
      [userId]: data,
    };
  }

  updateAllAccountToDefault() {
    this.allAccountsData = {};
  }

  updateEmailId(data) {
    this.emailIdDataForPortfolio = data;
  }

  updatePortfolioReportData(data) {
    this.portfolioReportData = data;
  }

  updateIsInitialAccountSelected(data) {
    this.isInitialAccountSelected = data;
  }

  updateTransactionReportData(data) {
    this.transectionTableData = data;
  }
  updateUpcomingtransectionTableData(data) {
    this.upcomingtransectionTableData = data;
  }
  updateRememberedTransactionReportData(data) {
    this.rememberedTransectionTableData = data;
  }
  updateRememberedupcomingtransectionTableData(data) {
    this.rememberedupcomingtransectionTableData = data;
  }

  updateTransactionCorporateReportData(data) {
    this.transectionCorporateTableData = data;
  }

  updateUpcomingtransectionCorporateTableData(data) {
    this.upcomingtransectionCorporateTableData = data;
  }
  updateRememberedTransactionCorporateReportData(data) {
    this.rememberedtransectionCorporateTableData = data;
  }
  updateRememberedUpcomingtransectionCorporateTableData(data) {
    this.rememberedupcomingtransectionCorporateTableData = data;
  }

  updateBillsNContractsData(data) {
    this.contractnBillData = data;
  }

  resetBillsAndContracts() {
    this.selectedReportType = "1";
    this.selectedSegment = "0";
  }

  // example api call
  async getAssetClassesData({ familyId = getCookie("famid") }) {
    if (familyId) {
      //apiClient;
      // .get(`families/${familyId}/portfolioassetclasses`)
      await portfolioAssetClasses({ isFamily: "families", id: familyId })
        .then(({ data }) => {
          this.allAssetClassesData = data;
          this.allAssetClassesAPIcallstate = "success";
          this.unrealisedReportFilter.selectedAssetClass = data[0];
          this.unrealisedChecks.assetClasses = 1;
          data.forEach((eachClass) => {
            this.getSubAssetClassesData({
              familyId,
              assetClassId: eachClass.id,
            });
          });
          AuthStore.updateLoadingFullScreen(false);
        })
        .catch((error) => {
          this.allAssetClassesAPIcallstate = "failure";
          AuthStore.updateLoadingFullScreen(false);
        });
    }
  }
  getAssetClassesDataWithClient({ userId }) {
    // apiClient
    //   .get(`clients/${userId}/portfolioassetclasses`)
    portfolioAssetClasses({ isFamily: "clients", id: userId })
      .then(({ data }) => {
        if (!data.length) {
          this.unrealisedReportFilter.selectedAssetClass = {
            className: "No Asset Class",
            classID: "noasset",
            nodata: true,
          };
          this.allAssetClassesData = [
            {
              className: "No Asset Class",
              key: "noasset",
              nodata: true,
            },
          ];
          this.subAssetFiltered = {
            noasset: [
              {
                className: "No Sub Asset Class",
                key: "nosubasset",
                nodata: true,
              },
            ],
          };
          this.allAssetClassesAPIcallstate = "success";
          this.unrealisedReportFilter.selectedSubAssetClass = {
            className: "No Sub Asset Class",
            classID: "noasset",
            nodata: true,
          };
          this.unrealisedChecks.assetClasses = 1;
          return;
        }
        this.allAssetClassesData = data;
        this.allAssetClassesAPIcallstate = "success";
        this.unrealisedReportFilter.selectedAssetClass = data[0];
        this.unrealisedChecks.assetClasses = 1;
        data.forEach((eachClass) => {
          this.getSubAssetClassesDataWithClient({
            userId,
            assetClassId: eachClass.id,
          });
        });
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        this.allAssetClassesAPIcallstate = "failure";
        AuthStore.updateLoadingFullScreen(false);
      });
  }
  getAllAccountsData(
    { userId, isLastClient, isFirstClient, reportType, idx, len },
    from,
  ) {
    userId &&
      // apiClient
      //   .get(`accountName?UserId=${userId}`)
      usersAccount({ userId })
        .then(({ data }) => {
          //  (!JSON.parse(getCookie("isPrimary")) ||
          //    UserStore.getData !== "fam")))
          AuthStore.updateLoadingFullScreen(false);
          this.updateAccounts(userId, data);
          if (Object.keys(this.allAccountsData).length === len) {
            this.allAccountsAPIcallstate = "success";
            this.unrealisedChecks.accountsSuccess = 1;
          }
          if (isFirstClient && reportType === "ledger") {
            this.updateLedgerFilter(
              {
                ...this.ledgerReportFilter,
                selectedAccount: data[0],
              },
              from,
            );
            this.selectedMarginAccount = data[0];
          }
          if (
            getDecodedToken()?.user_type === "manager" ||
            (getDecodedToken()?.user_type === "employee" &&
              (!UserStore.userData?.isprimary ||
                UserStore.getData !== "fam")) ||
            (getDecodedToken()?.user_type === "customer" &&
              (!JSON.parse(getCookie("isPrimary")) ||
                UserStore.getData !== "fam"))
          ) {
            this.allMembersAPIcallstate = "success";
            this.allAccountsAPIcallstate = "success";
          }
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(false);
          this.allAccountsAPIcallstate = "failure";
          if (
            getDecodedToken()?.user_type === "manager" ||
            (getDecodedToken()?.user_type === "employee" &&
              !UserStore.userData?.isprimary) ||
            (getDecodedToken()?.user_type === "customer" &&
              !JSON.parse(getCookie("isPrimary")))
          ) {
            this.allMembersAPIcallstate = "failure";
            this.allAccountsAPIcallstate = "failure";
          }
        });
  }

  async getprofile({ userId, onSuccess, onFail }) {
    await apiClient
      .get(`clients/${userId}`)
      .then(({ data }) => {
        if (
          getDecodedToken()?.user_type === "employee" &&
          UserStore.isSelectedUserPrimary
        ) {
          UserStore.forReportsInceptionDate = data.family_inceptiondate;
          this.inceptionDate = data.family_inceptiondate;
        } else if (
          getDecodedToken()?.user_type === "employee" &&
          !UserStore.isSelectedUserPrimary
        ) {
          UserStore.forReportsInceptionDate = data.client_inceptiondate;
          this.inceptionDate = data.client_inceptiondate;
        } else {
          UserStore.forReportsInceptionDate = data.client_inceptiondate;
          this.inceptionDate = data.client_inceptiondate;
        }
        UserStore.setFamilyName(data?.family_name);
        setCookie(
          "inceptionDates",
          JSON.stringify({
            client_inceptiondate: data.client_inceptiondate,
            family_inceptiondate: data.family_inceptiondate,
          }),
        );
        if (
          getDecodedToken()?.user_type === "customer" &&
          (data?.isprimary === true ||
            !JSON.parse(getCookie("isSelectedUserPrimary")))
        )
          setCookie("name", data.full_name);
        UserStore.setPagesApiStatus(
          "HomePageApiStatus",
          "profileData",
          "success",
        );
        AuthStore.updateLoadingFullScreen(false);

        const processReportTypeText = data.processReportType
          ? "(Inception)"
          : "(Transfer In)";

        UserStore.upDateData("usersData", processReportTypeText);
        onSuccess && onSuccess({ data, processReportTypeText });
      })
      .catch((error) => {
        onFail && onFail(error);
        UserStore.setPagesApiStatus(
          "HomePageApiStatus",
          "profileData",
          "failed",
        );
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getUserInceptionType({ onSuccess, onFail }) {
    const userId = getCookie("userid");
    getUsersInception({ userId })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((err) => {
        onFail(err);
      });
  }

  getUnrealisedAssetAndSubAssetClass({ userId, onSuccess, isMemberChanged }) {
    if (!isMemberChanged) this.unrealisedLoader = true;
    else this.unrealAssetClassesStatus = true;
    userId &&
      apiClient
        .get(
          `/GetUnrealisedRepostsAssetsandSubasset?userid=${userId}&clientcode=0`,
        )
        .then(({ data }) => {
          AuthStore.updateLoadingFullScreen(true);
          const assetClasses = data.filter(
            (eachClass) => eachClass.classType === "C",
          );
          const subAssetClasses = data.filter(
            (eachClass) => eachClass.classType === "S",
          );

          if (!assetClasses.length) {
            this.updateTableDataLoader(false);
            this.unrealisedReportFilter.selectedAssetClass = {
              className: "No Asset Class",
              classID: "noasset",
              nodata: true,
            };
            this.allAssetClassesData = [
              {
                className: "No Asset Class",
                key: "noasset",
                nodata: true,
              },
            ];
            this.subAssetFiltered = {
              noasset: [
                {
                  className: "No Sub Asset Class",
                  key: "nosubasset",
                  nodata: true,
                },
              ],
            };
            this.allAssetClassesAPIcallstate = "success";
            this.unrealisedReportFilter.selectedSubAssetClass = {
              className: "No Sub Asset Class",
              classID: "noasset",
              nodata: true,
            };
            this.unrealisedChecks.assetClasses = 1;
            if (!isMemberChanged) this.unrealisedLoader = false;
            else this.unrealAssetClassesStatus = false;
            AuthStore.updateLoadingFullScreen(false);
            return;
          }

          this.allAssetClassesData = assetClasses;
          this.allAssetClassesAPIcallstate = "success";
          this.unrealisedReportFilter.selectedAssetClass = assetClasses[0];
          this.unrealisedChecks.assetClasses = 1;

          this.allSubAssetClassesData = subAssetClasses;
          this.allSubAssetClassesAPIcallstate = "success";
          assetClasses.forEach((assetClass) => {
            const filteredSubAssetClass = subAssetClasses.filter(
              (subAssetClass) =>
                subAssetClass.primaryClassId === assetClass.classID,
            );
            this.subAssetFiltered = {
              ...this.subAssetFiltered,
              [assetClass.classID]: filteredSubAssetClass,
            };
          });
          if (
            this.subAssetFiltered[
              this.unrealisedReportFilter.selectedAssetClass.classID
            ]
          ) {
            this.unrealisedReportFilter.selectedSubAssetClass =
              this.subAssetFiltered[
                this.unrealisedReportFilter.selectedAssetClass.classID
              ]?.[0];
            this.unrealisedChecks.subAssetClasses = 1;
            if (!isMemberChanged) this.unrealisedLoader = false;
            else this.unrealAssetClassesStatus = false;
          }
          AuthStore.updateLoadingFullScreen(false);
          if (onSuccess) {
            onSuccess(data);
          }
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(false);
          this.unrealisedLoader = false;
        });
  }

  getSections() {
    // apiClient
    //   .get(`/sections`)
    sections()
      .then(({ data }) => {
        this.allSections = data;
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getDenominations({
    isOffshore,
    onSuccess,
    isUpdateFilter = true,
    reportRef = null,
  }) {
    // apiClient
    //   .get(`/denominations`)
    this.setReportsData("isFetchingDenominations", true);
    getDenominations({ isOffshore, signal: reportRef?.signal })
      .then(({ data }) => {
        // create denomination array
        const denomination = data?.map((eachDenomination) => {
          return {
            ...eachDenomination,
            value: eachDenomination.denomination,
            title: eachDenomination.denomination,
          };
        });

        const newDenomination = {
          ...this.allDenominations,
        };

        // Add new denomination array to the existing object
        newDenomination[isOffshore] = denomination;

        this.setReportsData("allDenominations", newDenomination);

        // Update portfolio filter at the first time when the page loads
        if (isUpdateFilter) {
          UserStore.portfolioReportFilter = {
            ...UserStore.portfolioReportFilter,
            denomination: denomination[0],
          };
        }

        // onSuccess is not called on the first time loading of the page
        // onSuccess is called when the report type filter is changed or the client is changed from the local filter
        onSuccess && onSuccess({ data: denomination });
        this.setReportsData("isFetchingDenominations", false);

        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        !error?.config?.signal?.aborted &&
          this.setReportsData("isFetchingDenominations", false);
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getEmailId({ empCode, userId }) {
    // apiClient
    //   .get(`GetEmail?EmpCode=${empCode}&UserId=${userId}`)
    emailIdsTax({ empCode, userId })
      .then(({ data }) => {
        this.updateEmailId(data[0]);
      })
      .catch((error) => {});
  }

  getLedgerSnapShotSummary(fromDate, toDate, currentAssetKeys) {
    let userId = "userid=";
    let startdate = "&startdate=";
    let enddate = "&enddate=";
    let account = "&account=";
    let assetKey = "&assetkey=";

    let selectedAccount = null;
    let currentUserId = null;

    for (let userId in this.allAccountsData) {
      // eslint-disable-next-line no-loop-func
      this.allAccountsData[userId].forEach((account) => {
        if (
          account.account_Code ===
          this.ledgerReportFilter.selectedAccount.account_Code
        ) {
          currentUserId = userId;
        }
      });
    }

    selectedAccount = this.ledgerReportFilter.selectedAccount.account_Code;

    apiClient
      .get(
        `LedgerSnapShotSummary?${userId}${currentUserId}${startdate}${fromDate}${enddate}${toDate}${account}${selectedAccount}${assetKey}${currentAssetKeys}`,
      )
      .then(({ data }) => {
        this.ledgerSnapshotAssetModalTableData = data;
        this.UpdateledgerSnapshotAssetModalTableDataLoader(false);
      })
      .catch((error) => {
        this.UpdateledgerSnapshotAssetModalTableDataLoader(false);
      });
  }

  setPortfolioReportObj(obj) {
    UserStore.portfolioReportObj = obj;
  }
  setFileNamePortfolio(fileName) {
    UserStore.portfolioReportFileName = fileName;
  }

  setDownloadTrigger(obj) {
    this.downloadTrigger = [...obj];
  }

  getPortfolioReports({ checker, payload, onSuccess, fileName }) {
    plainApiClient
      .post("PortfolioReports", payload, {
        headers: {
          Accept: "application/octet-stream",
        },
        responseType: "arraybuffer",
      })
      .then((res) => {
        if (checker) {
          AuthStore.updateLoadingFullScreen(false);
        }
        const data = res.data;
        this.updatePortfolioReportData(data);
        onSuccess();
        if (checker !== "btn") {
          var base64Str = Buffer.from(data).toString("base64");
          var binaryString = window.atob(base64Str);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          var arrBuffer = bytes;
          let file1 = new Blob([arrBuffer], { type: "application/pdf" });
          const url = window.URL.createObjectURL(file1);
          setCookie(
            "url",
            JSON.stringify({ url, fileName: `${payload.fileName}.pdf` }),
          );
          setTimeout(() => {
            window.close();
          }, 1100);
        }
      })
      .catch((error) => {
        if (!checker) {
          if (error?.response?.status === 504)
            UserStore.setPortfolioReportDownloadError(error?.response?.status);
          else UserStore.setPortfolioReportDownloadError(500);
        } else UserStore.setPortfolioReportDownloadError(500);
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getDataForTransectionReport(fromDate, toDate, isInfinity, data) {
    let familyId;
    if (
      getDecodedToken()?.user_type === "employee" ||
      getDecodedToken()?.user_type === "manager"
    ) {
      familyId = UserStore?.userData?.family_id || getCookie("famid");
    } else {
      familyId = getDecodedToken()?.family_id || getCookie("famid");
    }

    let postUrlForTransaction = "";
    let postUrlForUpcomingTransaction = "";

    let transaction_type = "&transaction_type=";
    let asset_class_id = "&asset_class_id=";
    let from_date = "from_date=";
    let to_date = "&to_date=";
    let account_code = "&account_code=";
    let users = "&users=";
    let infinity = "&isInfinity=";

    let transectionType = null;
    let upcomingtransectionType = null;
    let assetClassId = null;
    let selectedUsers = null;
    let selectedAccounts = null;

    transectionType =
      UserStore.transectionReportFilter.transectionType.join(",");

    upcomingtransectionType =
      UserStore.transectionReportFilter?.upcomingtransectionType?.join(",");

    if (UserStore.transectionReportFilter.selectedAssetClass === "All") {
      assetClassId = this.allAssetClassesData?.map((assetClass) => {
        return assetClass.id;
      });
    } else {
      assetClassId =
        UserStore.transectionReportFilter.selectedAssetClass.join(",");
    }

    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false")
    ) {
      selectedUsers = UserStore.userData?.user_id;
    } else {
      if (UserStore.transectionReportFilter.selectedMember === "All") {
        selectedUsers = UserStore.currentFamilyMembers?.map((familyMember) => {
          return familyMember?.user_id;
        });
      } else {
        selectedUsers = UserStore.transectionReportFilter.selectedMember.map(
          (familyMember) => familyMember?.user_id,
        );
      }
    }

    if (UserStore.transectionReportFilter.selectedAccount === "All") {
      selectedAccounts = Object.values(this.allAccountsData)
        ?.flat()
        ?.map((acc) => {
          return acc.account_Code;
        });
    } else if (UserStore.transectionReportFilter.selectedMember.length === 0) {
      selectedAccounts = "";
    } else {
      selectedAccounts =
        UserStore.transectionReportFilter.selectedAccount.account_Code;
    }

    const reportType = !isInfinity ? `IsAcquisition=${data.IsAcquisition}` : "";

    postUrlForTransaction = `${from_date}${fromDate}${to_date}${toDate}${transaction_type}${transectionType}${asset_class_id}${assetClassId}${users}${selectedUsers}${
      isInfinity ? "" : account_code
    }${isInfinity ? "" : selectedAccounts}${infinity}${isInfinity ? "1" : "0"}`;
    postUrlForUpcomingTransaction = `${transaction_type}${upcomingtransectionType}${asset_class_id}${assetClassId}${users}${
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false")
        ? UserStore.userData?.user_id
        : UserStore.currentFamilyMembers?.map((familyMember) => {
            return familyMember?.user_id;
          })
    }${account_code}${selectedAccounts}`;

    const recentTransactionQuery = !isInfinity
      ? postUrlForTransaction.concat("&", reportType)
      : postUrlForTransaction;
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0") ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false") ||
      UserStore?.selectedClientId !== "0" ||
      (typeof UserStore.transectionReportFilter.selectedMember !== "string" &&
        UserStore.transectionReportFilter.selectedMember?.length === 1)
    ) {
      // apiClient
      //   .get(
      //     `/clients/${selectedUsers}/recenttransactions?${postUrlForTransaction}`
      //   )
      transactionFilter({
        selectedUsers,
        postUrlForTransaction: recentTransactionQuery,
      })
        .then(({ data }) => {
          if (UserStore.transectionReportFilter.timePeriod === "last_10") {
            this.transectionTableData = data.clientTransactions?.slice(0, 10);
            this.updateRememberedTransactionReportData(
              data.clientTransactions?.slice(0, 10),
            );
          } else {
            this.transectionTableData = data.clientTransactions;
            this.updateRememberedTransactionReportData(data.clientTransactions);
          }
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });

      // apiClient
      //   .get(
      //     `/clients/${selectedUsers}/upcomingtransactions?${postUrlForUpcomingTransaction}`
      //   )
      transactionUpcomingFilter({
        selectedUsers,
        postUrlForUpcomingTransaction,
      })
        .then(({ data }) => {
          this.upcomingtransectionTableData = data.upcomingtransactions;
          this.updateRememberedupcomingtransectionTableData(
            data.upcomingtransactions,
          );
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });
    } else {
      apiClient
        .get(
          `/families/${familyId}/recenttransactions?${recentTransactionQuery}`,
        )
        .then(({ data }) => {
          if (UserStore.transectionReportFilter.timePeriod === "last_10") {
            this.transectionTableData = data.clientTransactions?.slice(0, 10);
            this.updateRememberedTransactionReportData(
              data.clientTransactions?.slice(0, 10),
            );
          } else {
            this.transectionTableData = data.clientTransactions;
            this.updateRememberedTransactionReportData(data.clientTransactions);
          }
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });

      apiClient
        .get(
          `/families/${familyId}/upcomingtransactions?${postUrlForUpcomingTransaction}`,
        )
        .then(({ data }) => {
          this.upcomingtransectionTableData = data.upcomingtransactions;
          this.updateRememberedupcomingtransectionTableData(
            data.upcomingtransactions,
          );
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });
    }
  }

  getDataForTransectionCorporateReport(fromDate, toDate, isInfinity) {
    let familyId;
    if (
      getDecodedToken()?.user_type === "employee" ||
      getDecodedToken()?.user_type === "manager"
    ) {
      familyId = UserStore?.userData?.family_id;
    } else {
      familyId = getDecodedToken()?.family_id;
    }

    let postUrlForCorporateActions = "";
    let postUrlForUpcomingCorporateActions = "";

    let transaction_type = "&TransactionType=";
    let asset_class_id = "&AssetClassId=";
    let from_date = "FromDate=";
    let to_date = "&ToDate=";
    let users = "&users=";
    let infinity = "&isInfinity=";

    let transectionType = null;
    let assetClassId = null;
    let selectedUsers = null;

    switch (UserStore.transectionCorporateActionReportFilter.transectionType) {
      case "interest":
        transectionType = "INTEREST";
        break;
      case "dividend":
        transectionType = "DIVIDEND";
        break;
      case "cash_dividend":
        transectionType = "CASHDIVIDEND";
        break;
      case "bonus":
        transectionType = "BONUS";
        break;
      case "split":
        transectionType = "SPLIT";
        break;
      case "buyback":
        transectionType = "BUYBACK";
        break;
      case "rights_issued":
        transectionType = "RIGHTSISSUED";
        break;
      case "principle_payback":
        transectionType = "PRINCIPLEPAYBACK";
        break;
      case "others":
        transectionType = "OTHERS";
        break;
      case "all":
        transectionType = "ALL";
        break;
      default:
        transectionType = "INTEREST";
        break;
    }

    if (
      UserStore.transectionCorporateActionReportFilter.selectedAssetClass ===
      "All"
    ) {
      assetClassId = this.allAssetClassesData?.map((assetClass) => {
        return assetClass.id;
      });
    } else {
      assetClassId =
        UserStore.transectionCorporateActionReportFilter.selectedAssetClass.join(
          ",",
        );
    }

    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false")
    ) {
      selectedUsers = UserStore.userData?.user_id;
    } else {
      if (
        UserStore.transectionCorporateActionReportFilter.selectedMember ===
        "All"
      ) {
        selectedUsers = UserStore.currentFamilyMembers?.map((familyMember) => {
          return familyMember?.user_id;
        });
      } else {
        selectedUsers =
          UserStore.transectionCorporateActionReportFilter.selectedMember.map(
            (familyMember) => familyMember?.user_id,
          );
      }
    }

    postUrlForCorporateActions = `${from_date}${fromDate}${to_date}${toDate}${transaction_type}${transectionType}${asset_class_id}${assetClassId}${users}${selectedUsers}${infinity}${
      isInfinity ? "1" : "0"
    }`;
    postUrlForUpcomingCorporateActions = `${transaction_type}${transectionType}${asset_class_id}${assetClassId}${users}${
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false")
        ? UserStore.userData?.user_id
        : UserStore.currentFamilyMembers?.map((familyMember) => {
            return familyMember?.user_id;
          })
    }`;
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0") ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken()?.primary === "false") ||
      UserStore?.selectedClientId !== "0" ||
      (typeof UserStore.transectionCorporateActionReportFilter
        .selectedMember !== "string" &&
        UserStore.transectionCorporateActionReportFilter.selectedMember
          ?.length === 1)
    ) {
      apiClient
        .get(
          `/clients/${selectedUsers}/corporateactions?${postUrlForCorporateActions}`,
        )
        .then(({ data }) => {
          this.transectionCorporateTableData = data.corporateActionList;
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateRememberedTransactionCorporateReportData(
            data.corporateActionList,
          );
          apiClient
            .get(
              `/clients/${selectedUsers}/corporateactions?type=upcoming${postUrlForUpcomingCorporateActions}`,
            )
            .then(({ data }) => {
              this.upcomingtransectionCorporateTableData =
                data.corporateActionList;
              this.allMembersAPIcallstate = "idle";
              this.allAssetClassesAPIcallstate = "idle";
              this.allAccountsAPIcallstate = "idle";
              this.updateRememberedUpcomingtransectionCorporateTableData(
                data.corporateActionList,
              );
              this.updateTableDataLoader(false);
            })
            .catch((error) => {
              this.allMembersAPIcallstate = "idle";
              this.allAssetClassesAPIcallstate = "idle";
              this.allAccountsAPIcallstate = "idle";
              this.updateTableDataLoader(false);
            });
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });
    } else {
      apiClient
        .get(
          `/families/${familyId}/corporateactions?${postUrlForCorporateActions}`,
        )
        .then(({ data }) => {
          this.transectionCorporateTableData = data.corporateActionList;
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateRememberedTransactionCorporateReportData(
            data.corporateActionList,
          );
          apiClient
            .get(
              `/families/${familyId}/corporateactions?type=upcoming${postUrlForUpcomingCorporateActions}`,
            )
            .then(({ data }) => {
              this.upcomingtransectionCorporateTableData =
                data.corporateActionList;
              this.allMembersAPIcallstate = "idle";
              this.allAssetClassesAPIcallstate = "idle";
              this.allAccountsAPIcallstate = "idle";
              this.updateRememberedUpcomingtransectionCorporateTableData(
                data.corporateActionList,
              );
              this.updateTableDataLoader(false);
            })
            .catch((error) => {
              this.allMembersAPIcallstate = "idle";
              this.allAssetClassesAPIcallstate = "idle";
              this.allAccountsAPIcallstate = "idle";
              this.updateTableDataLoader(false);
            });
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });
    }
  }

  updateLedgerDetailsData(data) {
    this.ledgerDetailedViewTableData = data;
  }

  setLedgerData() {
    this.ledgerDetailedViewTableData = null;
    this.rememberLedgerDetailedData = null;
  }

  getDataForLedgerReport(fromDate, toDate, selectedSegmentId) {
    let ledgerSnapShotPostUrl = "";
    let ledgerDetailedViewPostUrl = "";

    let account = "&account=";
    let segmentId = "&segmentid=";
    let startDate = "&startdate=";
    let userIdStr = "userid=";
    let endDate = "&enddate=";

    let selectedAccount = null;
    let currentUserId = null;

    for (let userId in this.allAccountsData) {
      // eslint-disable-next-line no-loop-func
      this.allAccountsData[userId].forEach((account) => {
        if (
          account.account_Code ===
          this.ledgerReportFilter.selectedAccount.account_Code
        ) {
          currentUserId = userId;
        }
      });
    }

    selectedAccount = this.ledgerReportFilter.selectedAccount.account_Code;

    ledgerSnapShotPostUrl = `${userIdStr}${currentUserId}${startDate}${fromDate}${endDate}${toDate}${account}${selectedAccount}`;
    ledgerDetailedViewPostUrl = `${userIdStr}${currentUserId}${startDate}${fromDate}${endDate}${toDate}${account}${selectedAccount}${segmentId}${selectedSegmentId}`;
    if (currentUserId && selectedAccount) {
      // apiClient
      //   .get(`/LedgerReports?${ledgerSnapShotPostUrl}`)
      ledgerReport({ url: ledgerSnapShotPostUrl })
        .then(({ data }) => {
          let newData = [];
          if (data.length) {
            data?.forEach((eachData, index) => {
              if (eachData?.isHeader === "1") {
                newData.push({
                  title: eachData.asset,
                  contentData: [],
                });
              } else {
                if (index !== 0) {
                  newData[newData.length - 1].contentData.push({
                    heading: eachData.asset,
                    value: eachData.assetVal,
                    assetKey: eachData.assetKey,
                  });
                }
                if (index === 0) {
                  newData.push({
                    title: "Activity in Your Account",
                    rightTitle: "Amount(₹)",
                    contentData: [
                      {
                        heading: eachData.asset,
                        value: eachData.assetVal,
                      },
                    ],
                  });
                }
              }
            });
          }
          const amtData = newData?.reduce((acc, cur) => {
            return acc + cur.contentData.length;
          }, 0);
          this.forLedgerNoDataScreen = amtData;
          this.ledgerSnapshotData = newData;
          this.ledgerSnapshotRawData = data;
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });

      // apiClient
      //   .get(`/LedgerDetailedReports?${ledgerDetailedViewPostUrl}`)
      ledgerReportDetails({ url: ledgerDetailedViewPostUrl })
        .then(({ data }) => {
          this.ledgerDetailedViewTableData = data;
          this.rememberLedgerDetailedData = data;
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        })
        .catch((error) => {
          this.allMembersAPIcallstate = "idle";
          this.allAssetClassesAPIcallstate = "idle";
          this.allAccountsAPIcallstate = "idle";
          this.updateTableDataLoader(false);
        });
    }
  }

  getUsersAccount(userId, idx) {
    this.getAccounts({
      userId: userId,
      onSuccess: (data) => {
        UserStore.currentFamilyMembers[idx].accountCode = data?.account_Code;

        for (let i = 0; i < data.length; i++) {
          this.usersAccounts.push({
            user_id: UserStore.currentFamilyMembers[idx].user_id,
            accountCode: data[i]?.account_Code,
            accountName: data[i]?.account_Name,
            full_name: UserStore.currentFamilyMembers[idx].full_name,
          });
        }
        this.isUsersAdded = true;
        UserStore.selectedAccount = this.usersAccounts[0];
        this.updateTableDataLoader(true);
        this.applyMarginFilter({
          reportType: "Overview",
          userId: this.usersAccounts[0].user_id,
          accountNo: this.usersAccounts[0].accountCode,
          onSuccess: (data) => {
            this.overviewFilterData = data;
            this.updateTableDataLoader(false);
          },
          onFail: (error) => {
            this.updateTableDataLoader(false);
          },
        });
        AuthStore.updateLoadingFullScreen(false);
      },
      onFail: () => {
        AuthStore.updateLoadingFullScreen(false);
      },
    });
  }

  setUsersAccountStatus(status) {
    this.usersAccountsfetchingStatus = status;
  }

  setBillFromDate(data) {
    this.billfromDate = data;
  }
  setBillToDate(data) {
    this.billtoDate = data;
  }

  setUsersAccount() {
    this.usersAccounts = [];
  }

  setSortedAccount() {
    this.usersAccounts = sortAccount(this.usersAccounts);
  }

  setIsFilterApplied(data) {
    this.isFilterApplied = data;
  }

  applyFilter(reportType, userId, accountNo) {
    this.applyMarginFilter({
      reportType,
      userId: UserStore.selectedAccount.user_id,
      accountNo: UserStore.selectedAccount.accountCode,
      onSuccess: (data) => {
        if (reportType === "Overview") {
          this.overviewFilterData = data;
        } else {
          let arr = data?.map((eachData, index) => {
            return { ...eachData, id: index };
          });
          this.valuationFilterData = arr;
          this.valuationTotal = arr.slice(0, data.length - 1);
        }
        this.isFilterApplied = true;
        this.selectedMarginAccount = UserStore.selectedAccount;
        this.updateTableDataLoader(false);
      },
      onFail: (error) => {
        this.updateTableDataLoader(false);
        this.isFilterApplied = false;
      },
    });
  }

  applyMarginFilter({ reportType, userId, accountNo, onSuccess, onFail }) {
    // apiClient
    //   .get(
    //     `MarginStatement${reportType}Reports?userid=${userId}&account=${accountNo}`
    //   )
    marginFilter({ reportType, userId, accountNo })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  downloadTaxReportPdfFile({ params, onSuccess, onFail }) {
    getTaxReportPdf({ params })
      .then((res) => {
        onSuccess(res);
        // setTimeout(() => {
        //   window.URL.revokeObjectURL(url);
        // }, 100);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  getUnrealGLReport({ controller, fileName, params, onSuccess, onFail }) {
    unrealisedGLReportPDfDownload({ params, controller })
      .then(({ data }) => {
        let file1 = new Blob([data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(file1);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  setReportsData(type, value) {
    this[type] = value;
  }

  setReportsStoreToIntialState() {
    this.allMembersData = null;
    this.allAssetClassesData = null;
    this.allSubAssetClassesData = null;
    this.subAssetFiltered = {};
    this.allAccountsData = null;
    this.filterApplied = false;
    this.tableDataLoader = true;
    this.unrealisedReportFilter = {
      selectedMember: undefined,
      selectedAssetClass: "All",
      selectedSubAssetClass: "All",
      selectedAccount: "All",
    };
    this.unrealisedReportData = undefined;
    this.unrealisedChecks = {
      memberSuccess: 0,
      accountsSuccess: 0,
      assetClasses: 0,
      subAssetClasses: 0,
    };
    this.unrealisedLoader = true;
    this.unrealAssetClassesStatus = false;
    this.allMembersAPIcallstate = "idle";
    this.allAssetClassesAPIcallstate = "idle";
    this.allAccountsAPIcallstate = "idle";
    this.inceptionDate = null;
    this.transectionTableData = null;
    this.rememberedTransectionTableData = null;
    this.upcomingtransectionTableData = null;
    this.rememberedupcomingtransectionTableData = null;
    this.selectedTabForTransaction = "recent_transaction";

    // transaction-corporate-action states
    this.transectionCorporateActionReportFilter = {
      timePeriod: "current_fy",
      transectionType: "interest",
      selectedMember: "All",
      selectedAssetClass: "All",
    };
    this.transectionCorporateTableData = null;
    this.upcomingtransectionCorporateTableData = null;
    this.selectedTabForTransactionCorporate = "recent_transaction_corporate";

    // ledger-report states
    this.isInitialAccountSelected = false;
    this.ledgerReportFilter = {
      timePeriod: "current_year",
      reportType: "snapshot",
      selectedAccount: {},
      selectedSegment: {
        title: "All",
        id: "1",
      },
    };
    this.ledgerSnapshotData = null;
    this.ledgerSnapshotRawData = null;
    this.ledgerDetailedViewTableData = null;
    this.rememberLedgerDetailedData = null;
    this.ledgerSnapshotAssetModalTableData = null;
    this.ledgerSnapshotAssetModalTableDataLoader = false;

    // portfolio report states
    this.allSections = null;
    this.allDenominations = {};
    this.emailIdDataForPortfolio = null;
    this.portfolioReportData = null;
    UserStore.portfolioReportFilter = {
      timePeriod: "current_month",
      denomination: {},
      selectedMember: "All",
      selectedAccount: "All",
      selectedAcquisitionDate: "Transfer-In Date",
      selectedSection: [1, 3],
    };
    // margin sections state
    this.usersAccountsfetchingStatus = "";
    this.isUsersAdded = false;
    this.usersAccounts = [];
    UserStore.selectedAccount = {};
    this.overviewFilterData = [];
    this.valuationFilterData = [];
    this.valuationTotal = [];
    this.mapUsersList = [];
    // bills and contract
    this.currentFamilyMembers = [];
    this.selectedReportType = "1";
    this.selectedSegment = "0";
    this.fromDate = null;
    this.toDate = null;
    this.contractnBillData = [];
    this.billfromDate = null;
    this.billtoDate = null;
    this.checkedArray = null;
    //tax reports
    this.selectedUserForEmail = "selfEmail";
    this.selectedUserForName = "selfName";
    this.selectedCharge = "0";
    this.emailIdDataForTax = {};
    this.canCallEmailApi = null;
    this.taxType = "Asset";
    this.assetData = [];
    this.interestData = [];
    this.assetTotal = null;
    this.intTotal = null;
    this.interestDivTotal = null;
    this.isTaxSendEmail = "";
    this.emailReportModalLoader = false;
    this.emaiDataGetSuccess = false;
    this.emailSendSuccess = false;
    this.reportsAsOfDate = "";
    this.taxReportEditColumnsNames = [
      {
        title: "Security Name",
        checked: true,
      },
      {
        title: "ISIN",
        checked: true,
      },
      {
        title: "Security Class",
        checked: true,
      },
      {
        title: "Quantity/Units",
        checked: true,
      },
      {
        title: "Buy Date",
        checked: true,
      },
      {
        title: "Sell Date",
        checked: true,
      },
      {
        title: "Buy Price in Rs",
        checked: true,
      },
      {
        title: "GF Price in Rs",
        checked: true,
      },
      {
        title: "Short Term",
        checked: false,
      },
      {
        title: "Sell Price in Rs",
        checked: false,
      },
      {
        title: "Buy Value in Rs",
        checked: false,
      },
      {
        title: "Indexation Price",
        checked: false,
      },
      {
        title: "Sell Value in Rs",
        checked: false,
      },
      {
        title: "Indexation Price",
        checked: false,
      },
      {
        title: "Indexation value",
        checked: false,
      },
      {
        title: "LTP",
        checked: false,
      },
      {
        title: "STT Buy",
        checked: false,
      },
      {
        title: "Taxable G/L with Indexation",
        checked: false,
      },
      {
        title: "Holding Days",
        checked: false,
      },
      {
        title: "Brokerage",
        checked: false,
      },
      {
        title: "Stamp Duty",
        checked: false,
      },
      {
        title: "Other Charges Buy",
        checked: false,
      },
      {
        title: "STT Sell",
        checked: false,
      },
      {
        title: "Other Charges Sell",
        checked: false,
      },
    ];
  }

  setSelectedAccount(account) {
    UserStore.selectedAccount = account;
  }

  setMapData(data) {
    this.mapUsersList = data;
  }

  setFromDate(date) {
    this.fromDate = date;
  }
  setToDate(date) {
    this.toDate = date;
  }

  setReportType(data) {
    this.selectedReportType = data;
  }

  setSegment(data) {
    this.selectedSegment = data;
  }

  setCanCallEmailApi(data) {
    this.canCallEmailApi = data;
  }

  setAllUserSetTrueFalse(isChecked) {
    this.contractnBillData.map((data) => (data.isChecked = !isChecked));
  }
  setSingleUserTrueFalse(id, state, key) {
    const newArr = this.contractnBillData;
    let newArr2 = newArr.map((data) => {
      if (data.id !== id) {
        return data;
      } else {
        return { ...data, isChecked: !state };
      }
    });

    this.contractnBillData = newArr2;
  }

  setSelectedCharges(data) {
    this.selectedCharge = data;
  }

  setTaxType(type) {
    this.taxType = type;
  }

  setTaxDataDefault(type) {
    this[type] = [];
  }

  getTaxApiData({ fromDate, toDate, onSuccess, onFail }) {
    // apiClient
    //   .get(
    //     `GetCapgainData${this.taxType}?userid=${UserStore.selectedAccount.user_id}&account=${UserStore.selectedAccount.accountCode}&startdate=${fromDate}&enddate=${toDate}&withChanges=${this.selectedCharge}`
    //   )
    taxFilter({
      taxType: this.taxType,
      userid: UserStore.selectedAccount.user_id,
      account: UserStore.selectedAccount.accountCode,
      startdate: fromDate,
      enddate: toDate,
      withChanges: this.selectedCharge,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  getBillsFilter({ fromDate, toDate, onSuccess, onFail }) {
    // apiClient
    //   .get(
    //     `BillContractReports?userid=${UserStore.selectedAccount.user_id}&account=${UserStore.selectedAccount.accountCode}&reporttype=${this.selectedReportType}&segmenttype=${this.selectedSegment}&startdate=${fromDate}&enddate=${toDate}`
    //   )
    billsFilter({
      userid: UserStore.selectedAccount.user_id,
      account: UserStore.selectedAccount.accountCode,
      reporttype: this.selectedReportType,
      segmenttype: this.selectedSegment,
      startdate: fromDate,
      enddate: toDate,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  setColumns(data) {
    this.taxReportEditColumnsNames = data;
  }

  setAssetData(data) {
    this.assetData = data;
  }
  setIntersetData(data) {
    this.interestData = data;
  }

  setAssetTotal(data) {
    this.assetTotal = data;
  }
  setIntTotal(data) {
    this.intTotal = data;
  }

  callPdfPi({ obj, onSuccess, onFail }) {
    plainApiClient
      .post(`CapgainReports`, obj)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  setITaxSendEmail(data) {
    UserStore.isTaxSendEmail = data;
  }
  setEmaiSendStatus(type, data) {
    this[type] = data;
  }

  getClientCodeForTax() {
    if (getDecodedToken()?.user_type !== "manager")
      return String(UserStore.selectedAccount.user_id);
    else return String(getCookie("selectedUsersId"));
  }

  downloadPortfolioExcel(obj, file) {
    plainApiClient
      .post(`DownloadPortfolioReportExcel`, obj, { responseType: "blob" })
      .then((res) => {
        var blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileName = `${file}.xlsx`;
        const url = URL.createObjectURL(blob);
        let anchorEl = document.createElement("a");
        anchorEl.href = url;
        anchorEl.download = `${fileName}`;
        anchorEl.click();
        anchorEl.remove();
        this.setEmaiSendStatus("excelDownloadStatus", "successfull");
      })
      .catch((error) => {
        this.setEmaiSendStatus("excelDownloadStatus", "failed");
      });
  }

  downloadPdf(fromDate, toDate, createdDate) {
    const obj = {
      ClientCode: this.getClientCodeForTax(),
      Account: UserStore.selectedAccount.accountCode,
      Tax_Report_Type: "",
      Asset: "All",
      From_Date: fromDate,
      To_Date: toDate,
      CreatedDate: createdDate,
      CreatedBy: getDecodedToken().user_id,
      Recipient_Name:
        UserStore.isTaxSendEmail === "1"
          ? UserStore.emailIdDataForTax[UserStore.selectedUserForName]
          : "",
      ToEmail:
        UserStore.isTaxSendEmail === "1"
          ? UserStore.emailIdDataForTax[UserStore.selectedUserForEmail]
          : "",
      isSendEmail: UserStore.isTaxSendEmail,
    };
    window.scrollTo(0, 0);
    if (UserStore.isTaxSendEmail === "0") {
      AuthStore.updateLoadingFullScreen(true);
    }
    plainApiClient
      .post(`CapgainReports`, obj, { responseType: "blob" })
      .then((res) => {
        const data = res?.data;
        if (res.status === 204) UserStore.setTaxReportDownloadError(204);
        else {
          if (UserStore.isTaxSendEmail === "0") {
            var blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const fileName = `Nuvama Tax Report - ${
              UserStore.selectedAccount?.accountName
            } - ${getCurrentDate()}_${getCurrentTime()}.xlsx`;
            const url = URL.createObjectURL(blob);
            setCookie("url", JSON.stringify({ url, fileName }));
            AuthStore.updateLoadingFullScreen(false);
            setTimeout(() => {
              window.close();
            }, 1100);
          } else {
            AuthStore.updateLoadingFullScreen(false);
            this.setEmaiSendStatus("emailSendSuccess", true);
            this.updateEmailReportModalLoader(false);
          }
        }
      })
      .catch((error) => {
        UserStore.setTaxReportDownloadError(500);
        this.setEmaiSendStatus("emailSendSuccess", false);
        this.updateEmailReportModalLoader(false);
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  callTaxApi(fromDate, toDate) {
    this.getTaxApiData({
      fromDate,
      toDate,
      onSuccess: (data) => {
        if (this.taxType === "Asset") {
          this.setAssetTotal(data.assetTotal);
        } else {
          this.setIntTotal(data.intDivTotal);
        }
        let dataArr = [];
        const objArr = Object.values(data);
        objArr.forEach((eachData, index) => {
          if (Array.isArray(eachData) && eachData.length !== 0) {
            for (let k = 0; k < eachData.length; k++) {
              if (
                eachData[k].parentDisplayID === "-2" ||
                (eachData[k].parentDisplayID === "-1" &&
                  eachData[k].ledger_Type === "Derivatives")
              ) {
                eachData[k].accordionContent = [];
                dataArr.push(eachData[k]);

                const rev = eachData.reverse();

                for (let i = 0; i < rev.length; i++) {
                  if (rev[i].parentDisplayID === "0") {
                    rev[i].tableData = [];
                    dataArr[dataArr.length - 1].accordionContent.push(rev[i]);
                    let accContentLength =
                      dataArr[dataArr.length - 1].accordionContent.length;
                    for (let j = 0; j < eachData.length; j++) {
                      if (
                        dataArr[dataArr.length - 1]?.accordionContent[
                          accContentLength - 1
                        ].displayID === eachData[j].parentDisplayID
                      ) {
                        dataArr[dataArr.length - 1]?.accordionContent[
                          accContentLength - 1
                        ].tableData.push(eachData[j]);
                      }
                    }
                  }
                }
              }
            }
          }
        });
        const set1 = new Set(dataArr);
        const arr2 = [...set1];

        const arrData = arr2?.map((eachData) => {
          return {
            ...getTaxAccordionData({ data: eachData }),
            accordionContent: eachData?.accordionContent?.map(
              (eachContaint) => {
                return {
                  ...getTaxAccordionData({ data: eachContaint }),
                  tableData:
                    eachContaint?.tableData &&
                    eachContaint?.tableData?.map((eachTableData) => {
                      return {
                        ...getTaxTableData({ data: eachTableData }),
                      };
                    }),
                };
              },
            ),
          };
        });

        if (this.taxType === "Asset") {
          this.setAssetData(arrData);
        } else {
          this.setIntersetData(arrData);
        }
        this.updateTableDataLoader(false);
      },
      onFail: (err) => {
        this.updateTableDataLoader(false);
        AuthStore.updateLoadingFullScreen(false);
      },
    });
  }

  applyBillsFilter(fromDate, toDate) {
    this.getBillsFilter({
      fromDate,
      toDate,
      onSuccess: (data) => {
        let newArr = data;
        let objectAddedArray = newArr.map((eachData, index) => {
          const fileDate = getDateInNum(eachData.file_Date);
          return {
            ...eachData,
            file_Date: fileDate,
            isChecked: false,
            id: index,
          };
        });

        this.contractnBillData = objectAddedArray;
        this.updateTableDataLoader(false);
      },
      onFail: (err) => {
        this.updateTableDataLoader(false);
      },
    });
  }

  callEmailApi({ empCode, userId, onSuccess, onFail }) {
    // apiClient
    //   .get(`GetEmail?EmpCode=${empCode}&UserId=${userId}`)
    emailIdsTax({ empCode, userId })
      .then(({ data }) => onSuccess(data))
      .catch((error) => {
        onFail(error);
      });
  }
  callEmailApiForClient({ userId, onSuccess, onFail }) {
    // apiClient
    //   .get(`GetEmail?EmpCode=&UserId=${userId}`)
    emailIdsTaxClient({ userId })
      .then(({ data }) => onSuccess(data))
      .catch((error) => {
        onFail(error);
      });
  }

  setTaxDates(obj, type) {
    UserStore[type] = obj;
  }

  setEmailIdCreds({ id, name }) {
    UserStore.selectedUserForEmail = id;
    UserStore.selectedUserForName = name;
  }

  getEmailIdForTax(user_id, isClient) {
    if (getDecodedToken()?.user_type === "employee") {
      this.callEmailApi({
        empCode: getDecodedToken().user_id,
        userId: user_id,
        onSuccess: (data) => {
          UserStore.emailIdDataForTax = data[0];
          this.setEmaiSendStatus("emaiDataGetSuccess", true);
        },
        onFail: (error) => {
          this.setEmaiSendStatus("emaiDataGetSuccess", false);
        },
      });
    } else {
      this.callEmailApiForClient({
        userId: user_id,
        onSuccess: (data) => {
          UserStore.emailIdDataForTax = data[0];
        },
        onFail: (error) => {},
      });
    }
  }

  getAccounts({ userId, onSuccess, onFail }) {
    userId &&
      // apiClient
      //   .get(`accountName?UserId=${userId}`)
      usersAccount({ userId })
        .then(({ data }) => {
          onSuccess(data);
        })
        .catch((error) => {
          onFail(error);
        });
  }

  setAllAccountStatus(data) {
    this.marginAllAccountsSuccess = data;
  }

  getUsersAccountBill(userId, idx, forApi, length) {
    this.getAccounts({
      userId: userId,
      onSuccess: (data) => {
        this.currentFamilyMembers[idx].accountCode = data?.account_Code;
        let dataToPush = null;
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            dataToPush = {
              user_id: this.currentFamilyMembers[idx].user_id,
              accountCode: data[i]?.account_Code,
              accountName: data[i]?.account_Name,
              full_name: this.currentFamilyMembers[idx].full_name,
            };
          }

          this.usersAccounts.push({
            user_id: this.currentFamilyMembers[idx].user_id,
            accountCode: data[i]?.account_Code,
            accountName: data[i]?.account_Name,
            full_name: this.currentFamilyMembers[idx].full_name,
          });
        }
        this.isUsersAdded = true;

        if (userId === UserStore.userData.user_id) {
          UserStore.selectedAccount = dataToPush;
          this.selectedMarginAccount = UserStore.selectedAccount;
        }

        if (idx === length - 1) {
          this.marginAllAccountsSuccess = true;
        }

        if (userId === UserStore.userData.user_id) {
          if (forApi === "margin") {
            this.updateTableDataLoader(true);
            this.applyMarginFilter({
              reportType: "Overview",
              userId: dataToPush.user_id,
              accountNo: dataToPush.accountCode,
              onSuccess: (data) => {
                this.overviewFilterData = data;
                this.updateTableDataLoader(false);
              },
              onFail: (error) => {},
            });
          }
        }
        if (userId === UserStore.userData.user_id) {
          if (forApi === "bill") {
            this.applyBillsFilter(
              `${this.billfromDate?.date}/${this.billfromDate?.month}/${this.billfromDate?.year}`,
              `${this.billtoDate?.date}/${this.billtoDate?.month}/${this.billtoDate?.year}`,
            );
          } else if (forApi === "tax") {
            if (
              getDecodedToken()?.user_type === "customer" ||
              getDecodedToken()?.user_type === "manager"
            ) {
              this.getEmailIdForTax(getCookie("selectedUsersId"));
            }
          }
        }
      },
      onFail: (error) => {
        AuthStore.updateLoadingFullScreen(false);
      },
    });
  }

  callLoop(data, forApi) {
    for (let i = 0; i < data.length; i++) {
      this.getUsersAccountBill(data?.[i]?.user_id, i, forApi, data?.length);
    }
  }

  getFamilyClients(forApi) {
    const familyId = getCookie("famid");
    // apiClient
    //   .get(`families/${familyId}/members`)
    familyMembers({ familyId })
      .then(({ data }) => {
        this.currentFamilyMembers = data;
        const forLiaison = data?.filter(
          (eachData) => String(eachData.user_id) === getCookie("userid"),
        );

        if (getCookie("isPrimary") !== "true") {
          this.setMapData(forLiaison);
          this.getSingleUsersAccount(getCookie("userid"));
        } else this.callLoop(data, forApi);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((err) => {
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  getSingleUsersAccount(userId, forApi) {
    this.updateTableDataLoader(true);
    this.getAccounts({
      userId: userId,
      onSuccess: (data) => {
        this.mapUsersList[0].accountCode = data?.account_Code;
        for (let i = 0; i < data.length; i++) {
          this.usersAccounts.push({
            user_id: this.mapUsersList[0].user_id,
            accountCode: data[i]?.account_Code,
            accountName: data[i]?.account_Name,
            full_name: this.mapUsersList[0].full_name,
          });
        }
        UserStore.selectedAccount = this.usersAccounts[0];
        this.selectedMarginAccount = this.usersAccounts[0];
        this.setSortedAccount();
        this.marginAllAccountsSuccess = true;
        if (forApi === "bill") {
          this.applyBillsFilter(
            `${this.billfromDate?.date}/${this.billfromDate?.month}/${this.billfromDate?.year}`,
            `${this.billtoDate?.date}/${this.billtoDate?.month}/${this.billtoDate?.year}`,
          );
        } else if (forApi === "margin") {
          this.updateTableDataLoader(true);
          this.applyMarginFilter({
            reportType: "Overview",
            userId: this.usersAccounts[0].user_id,
            accountNo: this.usersAccounts[0].accountCode,
            onSuccess: (data) => {
              this.overviewFilterData = data;
              this.updateTableDataLoader(false);
            },
            onFail: (error) => {},
          });
        } else if (
          forApi === "tax" &&
          (getDecodedToken()?.user_type === "customer" ||
            getDecodedToken()?.user_type === "manager")
        ) {
          this.getEmailIdForTax(getCookie("selectedUsersId"));
        }
        AuthStore.updateLoadingFullScreen(false);
      },
      onFail: () => {
        AuthStore.updateLoadingFullScreen(false);
      },
    });
  }

  billPdfDownload({ path, onSuccess, onFail }) {
    plainApiClient
      .get(`DownloadBillContract?path=${path}`, { responseType: "blob" })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  pdfDownloadForBills(path) {
    const filePath = path.split("\\");

    this.billPdfDownload({
      path,
      onSuccess: (data) => {
        var blob = new Blob([data], {
          type: "application/zip",
        });
        const blobUrl = URL.createObjectURL(blob);
        const anchorEl = document.createElement("a");
        const fileName = `${filePath[filePath.length - 1]}`;
        anchorEl.href = blobUrl;
        anchorEl.download = fileName;
        anchorEl.click();
        anchorEl.remove();
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      },
      onFail: (error) => {},
    });
  }

  getAsOfDate({ familyId, userId, onSuccess, onFail }) {
    if (PerformanceStore.famOrClient.name === "fam") {
      apiClient
        .get(
          `families/${familyId}/portfolioassetclasses/all/absoluteReturnperformance?duration=ITD&advisortype=${UserStore.getDataWithNuvamaOrOther}`,
        )
        .then(({ data }) => {
          onSuccess(data);
        })
        .catch((error) => {
          onFail(error);
        });
    } else {
      apiClient
        .get(
          `families/${userId}/portfolioassetclasses/all/absoluteReturnperformance?duration=ITD&advisortype=${UserStore.getDataWithNuvamaOrOther}`,
        )
        .then(({ data }) => {
          onSuccess(data);
        })
        .catch((error) => {
          onFail(error);
        });
    }
  }

  getInvestmentHeld({ userId, onSuccess, onFail }) {
    apiClient
      .get(`clients/${userId}`)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }
}

const Report = new ReportsStore();

export default Report;
